import * as React from 'react';

const CheckCircleFilled24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12 .526c6.074 0 11 4.927 11 11.001 0 6.075-4.926 11-11 11-6.075 0-11-4.925-11-11 0-6.074 4.924-11 11-11Zm4.64 7.232a1 1 0 0 0-1.409.128L11 12.964l-2.231-2.678a1 1 0 0 0-1.538 1.28l3 3.601a1 1 0 0 0 1.538 0l5-6a1 1 0 0 0-.128-1.41Z"
  }
));
CheckCircleFilled24.Size = 24;
CheckCircleFilled24.Title = "CheckCircleFilled";

export { CheckCircleFilled24 as default };
